import { render } from "./NextEventBubble.vue?vue&type=template&id=bd5e0146&scoped=true"
import script from "./NextEventBubble.vue?vue&type=script&lang=js"
export * from "./NextEventBubble.vue?vue&type=script&lang=js"

import "./NextEventBubble.vue?vue&type=style&index=0&id=bd5e0146&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5e0146"]])

export default __exports__